import { StackActions, useNavigation } from "@react-navigation/native";
import {
  Text,
  Image,
  TouchableOpacity,
  View,
  Keyboard,
  FlatList,
} from "react-native";

import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";

import { format } from "date-fns";
import { AppScreens } from "../../screens/Utility/AppScreens";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppImages } from "../../utility/AppImages";
import InviteSocialMediaModal from "../../screens/Auth/Event/InviteSocialMediaModal";
import { CommonButton } from "../../common/CommonButton";
import SignUpModal from "../../screens/Auth/WebScreens/Modals/SignUpModal";
import React, { useCallback, useMemo, useState } from "react";
import CommonTextInputWeb from "../../common/CommonTextInputWeb";

export default function SearchComponent({
  styles,
  searchEvent,
  setSearchEvent,
  setFilteredGames,
  genreGames,
  showSuggestions,
  setShowSuggestions,
}) {
  const deviceSize = useDeviceSize();

  const suggestions = useMemo(() => {
    if (!searchEvent.trim()) return [];

    const lowerCaseSearch = searchEvent.toLowerCase();

    const startsWithMatches = genreGames.filter((game) =>
      game.title.toLowerCase().startsWith(lowerCaseSearch)
    );

    const includesMatches = genreGames.filter(
      (game) =>
        game.title.toLowerCase().includes(lowerCaseSearch) &&
        !game.title.toLowerCase().startsWith(lowerCaseSearch)
    );

    // Combine both lists
    return [...startsWithMatches, ...includesMatches];
  }, [searchEvent, genreGames]);

  const handleInputChange = useCallback(
    (text) => {
      setSearchEvent(text);
      setShowSuggestions(text.trim() !== "");

      if (text.trim()) {
        const lowerCaseText = text.toLowerCase();

        const startsWithMatches = genreGames.filter((game) =>
          game.title.toLowerCase().startsWith(lowerCaseText)
        );

        const includesMatches = genreGames.filter(
          (game) =>
            game.title.toLowerCase().includes(lowerCaseText) &&
            !game.title.toLowerCase().startsWith(lowerCaseText)
        );

        setFilteredGames([...startsWithMatches, ...includesMatches]);
      } else {
        setFilteredGames(genreGames);
      }
    },
    [setSearchEvent, setFilteredGames, genreGames]
  );

  const onSuggestionSelect = useCallback(
    (suggestion) => {
      setSearchEvent(suggestion.title);
      setFilteredGames(
        genreGames.filter((game) => game.title === suggestion.title)
      );
      setShowSuggestions(false);
    },
    [setSearchEvent, setFilteredGames, genreGames]
  );

  return (
    <View style={{ position: "relative", zIndex: 1 }}>
      <View
        style={{
          height: 48,
          flexDirection: "row",
          alignItems: "center",
          gap: 16,
          marginBottom: 24,
          width: "100%",
        }}
      >
        <CommonTextInputWeb
          placeholder="Choose Games You Like"
          mainStyle={[styles.searchTextStyle]}
          inputStyle={[
            AppFontStyle.REGULAR_ANYBODY_12,
            {
              borderRadius: 8,
              backgroundColor: "#1F2937",
              borderWidth: 0.8,
              borderColor: "#374151",
              height: 48,
              paddingHorizontal: 16,
              color: AppColors.white,
              flexShrink: 0,
            },
          ]}
          prefixIconVisibility={false}
          onChangeText={handleInputChange}
          isPassword={false}
          value={searchEvent}
          onSubmitEditing={() => {
            Keyboard.dismiss();
          }}
          autoCapitalize="none"
        />
        {deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM ? null : (
          <CommonButton
            title="Search"
            textStyle={AppFontStyle.BOLD_ANYBODY_12}
            buttonStyle={{
              display: "flex",
              padding: 10,
              paddingHorizontal: 24,
              justifyContent: "center",
              alignItems: "center",
              gap: 10,
              borderRadius: 6,
              borderWidth: 1,
              borderColor: "#FFF",
              backgroundColor: "transparent",
              shadowOpacity: 0,
              height: 48,
              minWidth: 120,
            }}
          />
        )}
        {showSuggestions && suggestions.length > 0 && (
          <View style={styles.suggestionBox}>
            <FlatList
              data={suggestions}
              keyExtractor={(item) => item.id}
              renderItem={({ item }) => (
                <TouchableOpacity
                  onPress={() => onSuggestionSelect(item)}
                  style={styles.suggestionItem}
                >
                  <Text style={{ color: AppColors.white }}>{item.title}</Text>
                </TouchableOpacity>
              )}
            />
          </View>
        )}
      </View>
    </View>
  );
}
